const AVATAR_COLORS = [
  { id: 'gray', name: 'gray', value: '#A9A9A9' },
  { id: 'grape', name: 'grape', value: '#62466B' },
  { id: 'purple', name: 'purple', value: '#976CA4' },
  { id: 'blue', name: 'blue', value: '#5793F3' },
  { id: 'navy', name: 'navy', value: '#3B5DB2' },
  { id: 'green', name: 'green', value: '#8D9C00' },
  { id: 'teal', name: 'teal', value: '#7ECBD2' },
  { id: 'pink', name: 'pink', value: '#CC7B9D' },
  { id: 'red', name: 'red', value: '#C05A5D' },
];

// Generate consistent color based on user identifier
export const getConsistentAvatarColor = (user: any): string => {
  if (user.color) {
    return user.color;
  }

  // Generate a consistent color based on email or name
  const str = user.email || user.name || 'default';
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const colors = [
    '#FF6B6B',
    '#4ECDC4',
    '#45B7D1',
    '#96CEB4',
    '#FECA57',
    '#FF9FF3',
    '#54A0FF',
    '#5F27CD',
    '#00D2D3',
    '#FF9F43',
    '#10AC84',
    '#EE5A24',
    '#0984E3',
    '#6C5CE7',
    '#FD79A8',
  ];

  return colors[Math.abs(hash) % colors.length];
};

export const getUserDisplayName = (user: any): string => {
  if (user.first_name && user.last_name) {
    return user?.first_name?.charAt(0) + user?.last_name?.charAt(0) || user.email;
  }
  return user.email || user.name || 'Unknown User';
};

export { AVATAR_COLORS };
